import { createReducer, on } from '@ngrx/store';
import * as PaymentInfoActions from '../actions/payment-info.actions';

export const paymentInfoFeatureKey = 'paymentInfo';

export interface State {
  record: any;
  error: any;
  loaded: boolean;
  loading: boolean;
}

export const initialState: State = {
  record: null,
  error: null,
  loaded: false,
  loading: false,
};


export const reducer = createReducer(
  initialState,

  on(PaymentInfoActions.loadPaymentInfo, (state) => ({
    record: state.record,
    error: null,
    loaded: false,
    loading: true,
  })),
  on(PaymentInfoActions.loadPaymentInfoSuccess, (state, action) => ({
    record: action.data,
    error: null,
    loaded: true,
    loading: false,
  })),
  on(PaymentInfoActions.loadPaymentInfoFailure, (state, action) => ({
    record: null,
    error: action.error,
    loaded: false,
    loading: false,
  })),
  on(PaymentInfoActions.clearPaymentInfoState, () => ({
    record: null,
    error: null,
    loaded: false,
    loading: false,
  })),
);

